import { WarningIconGrey } from './icons'
import React from 'react'

export function WarningPopupGraphic() {
  return (
    <img
      src={WarningIconGrey}
      alt=""
      style={{ margin: '10px auto', display: 'block' }}
    />
  )
}